import React, { useEffect, useState } from "react";
import AndroidCabItem from "./AndroidCabItem";
import {
  getBookingSearchFormatedDateValue,
  getBookingFormatedValue,
  getTimeDifference,
  getTimeDifferenceNew,
  formatDateHumanFriendly,
} from "../../utils/Functions";
import { useNavigate } from "react-router-dom";
import AndroidFormIcon from '../../assets/androidFormIcon.png'
import { useBoardingDropping } from "../../context/BoardingDroppingContext";
import { getCategoryByData } from "../../utils/api.functions";
import Loader from "../loader";
import { CITY_ID } from "../../utils/common.data";
import "./style.css";

const AndroidBookingPage = ({ handleView }) => {
  const [viewSeatId, setViewSeatId] = useState(null);
  const navigate = useNavigate();
  const [searchDetail, setSearchDetail] = useState({
    boarding: "",
    dropping: "",
    travel_date: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [category, setCategory] = useState([]);
  const [view, setView] = useState(0);

  const { boardingDroppingPoints, fetchBoardingDroppingPoints,categoryTags,fetchCategoryTagsList } =
    useBoardingDropping();

  useEffect(() => {
    if (!boardingDroppingPoints) {
      fetchBoardingDroppingPoints(); // Fetch data if not already available
    }
  }, [boardingDroppingPoints, fetchBoardingDroppingPoints]);

  useEffect(() => {
    if (!categoryTags) {
      fetchCategoryTagsList(); // Fetch data if not already available
    }
  }, [categoryTags, fetchCategoryTagsList]);

  useEffect(() => {
    const searchData = sessionStorage.getItem("bookingdetails");
    if (searchData) {
      try {
        const searchValue = JSON.parse(searchData);
        setSearchDetail({
          ...searchDetail,
          ...searchValue,
          travel_date: searchValue?.date,
        });
        fetchCategories(searchValue);
      } catch (error) {
        console.log(`search Data Err`, error);
      }
    }
  }, []);

  // useEffect(() => {
  //   let username = sessionStorage.getItem("auth");
  //   if (username === "" || username === null) {
  //     navigate("/login");
  //   }
  // }, []);

  const handleCategoryData = (val, category) => {
    if (category) return val?.filter((value) => value.category_id == category);
    return val.sort((a, b) => {
      return new Date(a.departure) - new Date(b.departure);
    });
  };

  const handleCategoryViewCab = (val, category) => {
    return val?.filter((value) => value.category_id !== category);
  };

  const handleCloseViewCab = () => {
    setViewSeatId(null);
  };

  const fetchCategories = async (value) => {
    const apiKey = sessionStorage.getItem("key");
    try {
      const response = await getCategoryByData(
        { ...value, city_id: CITY_ID },
        apiKey
      );
      ////console.log({ response });

      if (response.status === 200) {
        const newData = response?.data?.resDecrypt?.response;

        // Check if the category data already exists
        if (newData && newData.length > 0) {
          // Assuming the data has a unique identifier like category_id
          const newCategoryIds = newData.map((item) => item.category_id);

          setCategory((prevCategories) => {
            // Filter out existing categories that already exist in newData
            const filteredPrevCategories = prevCategories?.filter(
              (item) => !newCategoryIds.includes(item.category_id)
            );

            // Merge the previous categories and new data
            const updatedCategories = [...filteredPrevCategories, ...newData];

            setIsLoading(false); // Disable loading once data is fetched
            return updatedCategories; // Return the merged data
          });
        } else {
          setIsLoading(false); // Disable loading if no data
        }
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Category Error", error);
      setIsLoading(false); // Disable loading in case of an error
    }
  };

  const handleSeatArrayData = (cat_max_size, seat_price, seatBooked, fallbackPrice) => {
    const seatBookedValue = seatBooked || [];
    const maxSize = Math.max(1, parseInt(cat_max_size, 10) || 20);
    const normalPrice = parseFloat(seat_price?.normal) || parseFloat(fallbackPrice) || 0;
    const windowPrice = parseFloat(seat_price?.window) || normalPrice;
    const isBooked = (idx) => seatBookedValue.some((s) => Number(s) === idx);
    return Array(maxSize)
      .fill()
      .map((_, index) => {
        const seatNum = index + 1;
        return {
          id: `c${seatNum}`,
          seat_id: seatNum,
          available: !isBooked(seatNum),
          normal: normalPrice,
          window: windowPrice,
        };
      });
  };

  const handleViewChange = (val) => {
    if (handleView) {
      handleView();
      return;
    }
    ////setView(val)
    navigate("/booknow");
  };

  return (
    <div className="android_booking_page_container main_booking_page_container st_slider_index_sidebar_main_wrapper st_slider_index_sidebar_main_wrapper_booking">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {/* <div className="search_data_main_new_container">
              <div
                className="search_data_main_new_container_first"
                onClick={() => {
                  handleViewChange("/booknow");
                }}
              >
                <i className="fas fa-chevron-left"></i>
              </div>
              <div className="search_data_main_new_container_middle">
                <div className="search_data_main_new_container_middle_first">
                  <div className="search_data_main_new_container_middle_first_board">
                    {searchDetail?.boarding}
                  </div>
                  <div className="search_data_main_new_container_middle_first_arrow">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                  <div className="search_data_main_new_container_middle_first_depart">
                    {searchDetail?.dropping}
                  </div>
                </div>
                <div className="search_data_main_new_container_middle_second">
                  {formatDateHumanFriendly(new Date(searchDetail?.travel_date))}
                </div>
              </div>
              <div className="search_data_main_new_container_last">Filter</div>
            </div> */}
            {view === 0 ? (
              <div className="search_data_main">
                <div className="search_data_main_board">
                  {searchDetail?.boarding}
                </div>
                <div className="search_data_main_arrow android_search_data_main_arrow">
                  {/* <i className="fas fa-arrow-right"></i> */}
                  <img src={AndroidFormIcon} alt="arrow" />
                </div>
                <div className="search_data_main_depart">
                  {searchDetail?.dropping}
                </div>
                <div className="search_data_main_time">
                  {getBookingSearchFormatedDateValue(
                    new Date(searchDetail?.travel_date)
                  )}
                </div>
                <div className="search_data_main_button">
                  <button
                    className="common_button_border"
                    type="button"
                    onClick={() => {
                      handleViewChange("/booknow");
                    }}
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      <div className="container new_booking_padding_container">
        <div className="row">
          {(isLoading || !isLoading) && (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              {isLoading && <Loader />}
              {!isLoading && category && category?.length == 0 && (
                <div className="no_data_found">
                  <h3>No ride for this day</h3>
                </div>
              )}
            </div>
          )}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {category && category?.length > 0 && (
              <div id="home" className="tab-pane active">
                {/* <aside className="booking_card_item_list_date">
                  {formatDateHumanFriendly(new Date(searchDetail?.travel_date))}
                </aside> */}
                <div className="booking_card_item_list">
                  {handleCategoryData(category, viewSeatId).map(
                    (categoryItem) => (
                      <AndroidCabItem
                        busValue={{
                          ...categoryItem,
                          seats: handleSeatArrayData(
                            categoryItem?.cat_max_size,
                            categoryItem?.seat_price,
                            categoryItem?.bookedSeat,
                            categoryItem?.price
                          ),
                        }}
                        key={categoryItem?.category_id}
                        id={categoryItem?.category_id}
                        name={categoryItem?.cat_name}
                        images={categoryItem?.cat_icon_path}
                        price={categoryItem?.price}
                        departure={getBookingFormatedValue(
                          new Date(categoryItem?.departure)
                        )}
                        arrival={getBookingFormatedValue(
                          new Date(categoryItem?.arrival)
                        )}
                        duration={getTimeDifferenceNew(
                          new Date(categoryItem?.departure),
                          new Date(categoryItem?.arrival)
                        )}
                        rating={categoryItem?.driver?.d_rating}
                        ratingCount={categoryItem?.driver?.d_rating_count}
                        seatsAvailable={categoryItem?.seatsAvailable}
                        fetchCategories={() => {
                          fetchCategories({
                            category_id: categoryItem?.category_id,
                            date: searchDetail.travel_date,
                          });
                        }}
                        viewSeatId={viewSeatId} // Pass the state
                        setViewSeatId={setViewSeatId} // Pass the setter
                        handleApiRedirect={handleView}
                        categoryTags={categoryTags}
                      />
                    )
                  )}
                </div>
                {viewSeatId &&
                  handleCategoryViewCab(category, viewSeatId).length > 0 && (
                    <div className="booking_card_item_list_count">
                      <div
                        onClick={() => {
                          handleCloseViewCab();
                        }}
                      >
                        <span>
                          {handleCategoryViewCab(category, viewSeatId).length}
                        </span>
                        <span>Rides</span>{" "}
                        <i
                          className="fas fa-chevron-down"
                          aria-hidden="true"
                        ></i>{" "}
                      </div>{" "}
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AndroidBookingPage;
